import type { DeliveryStatus } from '@/api/endpoints/inventory-deliveries'

/**
 * Badge variant per delivery status, shared by the list and the detail header.
 * Overdue is not a status: it is rendered as an extra `destructive` badge next to these.
 */
export const DELIVERY_STATUS_VARIANT: Record<
  DeliveryStatus,
  'default' | 'secondary' | 'outline'
> = {
  ANNOUNCED: 'default',
  BOOKED: 'secondary',
  CANCELLED: 'outline',
}
